import { createActions } from 'redux-actions';
import { GetCommissionSharesParams } from '@apis/CommissionShareApi';
import { CommissionShareOrder } from '@models/Commission';
import { Pagination } from '@models/Pagination';

export type State = {
  commissionShares: CommissionShareOrder[];
  loading: boolean;
  error: string | null;
  pagination?: Pagination;
};

export type CommissionSharesFetchPayload = GetCommissionSharesParams;
export type StateUpdatePayload = Partial<State>;

export const {
  commissionSharesFetch,
  stateUpdate,
  clearError,
} = createActions(
  'COMMISSION_SHARES_FETCH',
  'STATE_UPDATE',
  'CLEAR_ERROR',
  {
    prefix: 'USER_DASHBOARD_COMMISSION_SHARES',
  },
);
